module.exports = __webpack_public_path__ + "static/media/1.042ea531.mp4";